import { useState, useRef } from "react";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { MuiDialog } from "styles/jss/Layout.styles";
import { CustomTextField } from "styles/jss/Inputs.styles";
import { Box, Button, Container, DialogTitle } from "@mui/material";
import { SearchIcon, CloseIcon } from "../IconsSvg";
import SearchInput from "./SearchInput";

const SearchDialog = () => {
  const { t } = useTranslation(["nav"]);

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box>
      <i className={"searchIcon"} onClick={handleClickOpen}>
        <SearchIcon />
      </i>
      <MuiDialog open={open} onClose={handleClose}>
        <Container>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <DialogTitle>{t("search.title")}</DialogTitle>
            <Button className={"close"} onClick={handleClose}>
              <CloseIcon />
            </Button>
          </Box>
          <Box sx={{ padding: "20px" }}>
            <SearchInput />
          </Box>
        </Container>
      </MuiDialog>
    </Box>
  );
};

export default SearchDialog;
